import React, { Component, createRef } from "react";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";

import { useStyles } from "../../../../Components/CSS/FormStyle.css";
import Axios from "axios";
import { url } from "../../../../Config/Config";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import GradeForm from "../GradeForm/GradeForm";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";

class AddGrade extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ref: {
        percentFromRef: createRef(),
        percentToRef: createRef(),
        gradeRef: createRef(),
      },
      data: {
        name: "",
        percentFrom: 0,
        percentTo: 0,
        gradeNumber: 0,
      },
      error: {
        percentFromError: "",
        percentToError: "",
        gradeNumberError: "",
      },
      gradeError: "",
      loading: false,
    };
  }

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleWheel = (refValue) => {
    refValue.current.blur();
    setTimeout(() => refValue.current.focus(), 100);
  };

  checkError = () => {
    let percentFromError = "";
    let percentToError = "";
    let gradeNumberError = "";

    if (this.state.data.percentFrom < 0) {
      percentFromError = "The value must not be less than or equals to zero";
    }

    if (this.state.data.percentTo < 0) {
      percentToError = "The value must not be less than or equals to zero";
    }

    if (this.state.data.gradeNumber < 0) {
      gradeNumberError = "The value must not be less than or equals to zero";
    }

    if (percentFromError || percentToError || gradeNumberError) {
      this.setState({
        error: {
          percentFromError,
          percentToError,
          gradeNumberError,
        },
      });
      return true;
    } else {
      this.setState({
        error: {
          percentFromError: "",
          percentToError: "",
          gradeNumberError: "",
        },
      });
      return false;
    }
  };

  checkError = (grade) => {
    let gradeError = grade ? grade : "";
    if (gradeError) {
      this.setState({ gradeError });
      return true;
    } else {
      this.setState({ gradeError: "" });
      return false;
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      try {
        this.setState({ loading: true });
        const response = await Axios.post(
          `${url}/api/grades`,
          this.state.data,
          {
            headers: {
              Authorization: `Bearer ${this.props.adminToken}`,
            },
          }
        );
        if (response.data.message === "Grade saved successfully") {
          this.setState({
            data: {
              name: "",
              percentFrom: 0,
              percentTo: 0,
              gradeNumber: 0,
            },
            loading: false,
          });
          this.props.getGrades();
        }
      } catch (error) {
        this.setState({ loading: false });
        if (
          error.response.data.message === "Grade with given name already exists"
        ) {
          console.clear();
          this.checkError(error.response.data.message);
        }
        if (
          error.response.data === "jwt expired" &&
          error.response.status === 401
        ) {
          console.clear();
          let refreshToken = { refreshToken: this.props.refreshToken };
          this.props.getAdminRefreshToken(refreshToken, this.props.role);
          this.handleSubmit(e);
        }
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Paper className={classes.paper}>
          <GradeForm
            loading={this.state.loading}
            data={this.state.data}
            reference={this.state.ref}
            gradeError={this.state.gradeError}
            handleWheel={this.handleWheel}
            handleChange={this.handleChange}
            handleSubmit={this.handleSubmit}
          />
        </Paper>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(AddGrade)));
